import { render, staticRenderFns } from "./Managers.vue?vue&type=template&id=77850c50"
import script from "./Managers.vue?vue&type=script&lang=js"
export * from "./Managers.vue?vue&type=script&lang=js"
import style0 from "./Managers.vue?vue&type=style&index=0&id=77850c50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports